module.exports = function(){
    function interval(cb, delay){
        return setInterval(cb, delay);
    }
    interval.clear = function (t) {
        return clearInterval(t);
    };
    return interval;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/jpex-defaults/src/$interval.js
// module id = v8ch
// module chunks = 0